import { useEffect, useState } from "react";
function useSticky(ref) {
  var _useState = useState(false),
    isSticky = _useState[0],
    setIsSticky = _useState[1];
  useEffect(function () {
    if (!ref.current) {
      console.error("The ref provided to useSticky is not attached to any element.");
      return;
    }
    var handleScroll = function handleScroll() {
      var element = ref.current;
      var computedStyle = window.getComputedStyle(element);
      var stickyTop = parseInt(computedStyle.top || "0", 10);
      var isCurrentlySticky = computedStyle.position === "sticky" && element.getBoundingClientRect().top === stickyTop;
      setIsSticky(isCurrentlySticky);
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Initial check in case the element is already sticky
    handleScroll();

    // Cleanup listener on unmount
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [ref]);
  return isSticky;
}
export default useSticky;